module.exports = __webpack_public_path__ + "static/media/toggle-left.a0415bfe.svg";